export default __webpack_public_path__ + "static/media/BACKGROUND.dcc43ccc.jpg";